import type { ActiveExecution } from "@/stores/companion-store";
import type { AgentCursor as AgentCursorData } from "@/stores/canvas-store";

export function isVisibleAgentCursorWork(cursor: AgentCursorData): boolean {
  if (cursor.origin !== "heartbeat") return true;
  return !!(
    cursor.taskId ||
    cursor.content ||
    cursor.contentFull ||
    cursor.error ||
    cursor.question
  );
}

export function isVisibleAgentExecutionWork(
  execution: ActiveExecution,
): boolean {
  if (execution.origin !== "heartbeat") return true;
  return !!execution.taskId;
}
